export default __webpack_public_path__ + "static/media/c3fb9cb0f44e0511.174954c7dc028052d0db40ee227152b8.svg";